<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการข้อมูลรายการส่งเสริมการขายอินเทอร์เน็ตความเร็วสูงประจำที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลอินเทอร์เน็ตประจำที่
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <div class="pull-right box_add" v-if="user_permission.add">
                      <button
                        @click="add_promotion_dialog('CMS')"
                        style="margin-right:2px;"
                        class="btn btn-info btn_custom"
                      >
                        <i class="fa fa-plus"></i> เพิ่มรายการส่งเสริมการขาย
                      </button>
                      <el-dialog title="'เพิ่มรายการส่งเสริมการขาย'" :visible.sync="addPromotionDialog" center>
                        <el-form :model="dialogData" :label-position="'left'">
                          <el-form-item label="รอบการนำส่งข้อมูลประจำเดือน (เดือน/ปี)" required>
                            <el-select v-model="monthly_regulate">
                              <el-option v-for="item in regulate_list" :key="item.data"  :value="item.data" :label="item.label"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                          <el-button @click="addPromotionDialog = false">ปิดหน้าต่าง</el-button>
                          <el-button type="primary" @click="addPromotion()">ยืนยัน</el-button>
                        </span>
                      </el-dialog>
                      <button
                        @click="add_promotion_dialog('PDF')"
                        style="margin-left:1=2px;"
                        class="btn btn-warning"
                      >
                        <i class="fa fa-plus"></i> อัปโหลดไฟล์ PDF
                      </button>
                    </div>
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ชื่อรายการส่งเสริมการขาย" prop="promotion_name">
                            <el-input clearable v-model="form.promotion_name"></el-input>
                          </el-form-item>
                          <el-form-item label="ชนิดของรายการส่งเสริมการขาย" prop="promotion_type">
                            <el-select filterable v-model="form.promotion_type" clearable>
                              <el-option label="ทั้งหมด" :value='null'></el-option>
                              <el-option label="รายการส่งเสริมการขายหลัก (Main)" value="main"></el-option>
                              <el-option label="รายการส่งเสริมการขายเสริม (On-top)" value="on-top"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ผู้ให้บริการ" prop="provider">
                            <el-select filterable v-model="form.provider_id" :disabled="!!this.isProvider">
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option v-for="provider in this.providers" :key="provider.id" :label="provider.name" :value="provider.info"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ประเภทเทคโนโลยีของการให้บริการ" prop="promotion_technology">
                            <el-select filterable v-model="form.promotion_technology" clearable>
                              <el-option label="ทั้งหมด" :value="null"></el-option>
                              <el-option label="FTTx" value="FTTx"></el-option>
                              <el-option label="VDSL" value="VDSL"></el-option>
                              <el-option label="ADSL" value="ADSL"></el-option>
                              <el-option label="WiFi" value="WiFi"></el-option>
                              <el-option label="VAS" value="VAS"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="สถานะการให้บริการ">
                            <el-checkbox-group v-model="form.service_status">
                              <div class="col-md-6">
                                <el-checkbox label="S">(S) เฉพาะรายการส่งเสริมการขายใหม่ (ยังขายอยู่)</el-checkbox><br/>
                                <el-checkbox label="U">(U) ไม่ขายแล้วแต่ยังให้บริการอยู่</el-checkbox><br/>
                                <el-checkbox label="X">(X) ยกเลิกการให้บริการแล้ว</el-checkbox>
                              </div>
                              <div class="col-md-6">
                                <el-checkbox label="CS">(CS) Corporate (ยังขายอยู่)</el-checkbox><br/>
                                <el-checkbox label="CU">(CU) Corporate (ไม่ขายแล้วแต่ยังให้บริการอยู่)</el-checkbox><br/>
                                <el-checkbox label="CX">(CX) Corporate (ยกเลิกการให้บริการแล้ว)</el-checkbox>
                              </div>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="สถานะของรายการส่งเสริมการขาย">
                            <el-radio-group v-model="form.promotion_status">
                              <el-radio label="active">ให้บริการตามปกติ</el-radio>
                              <el-radio label="processing">ระหว่างดำเนินการแก้ไข</el-radio>
                              <el-radio label="suspend">ระงับการใช้งานชั่วคราว</el-radio>
                              <el-radio label="delete">รายการที่ถูกลบ</el-radio>
                              <el-radio label="">ทั้งหมด</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="ช่วงราคา (บาท)" class="slider_price">
                            <el-slider
                              v-model="form.price_range"
                              :step="100"
                              range
                              :max="1600"
                              :show-input="true"
                              :show-stops="true"
                              :format-tooltip="changeTooltip"
                              :marks="{0:'0',100:'100',200:'200',300:'300',400:'400',500:'500',600:'600',700:'700',800:'800',900:'900',1000:'1000',1100:'1100',1200:'1200',1300:'1300',1400:'1400',1500:'1500', 1600:'1500 ขึ้นไป'}"
                            ></el-slider>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button @click="loadData" class="btn btn-primary" type="button">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>

              <!-- table -->
              <div class="table-responsive">
                <div class="box-body">
                  <data-tables-server
                    @query-change="loadData"
                    :data="table_data"
                    :total="total"
                    :page-size="10"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    :table-props="tableProps"
                  >
                  <el-table-column sortable="custom" prop="cr_status" label="สถานะของรายการส่งเสริมการขาย" width="250">
                    <template slot-scope="scope" > {{ scope.row.deleted_at != "" && scope.row.deleted_at != null ? 'ถูกลบแล้ว' : scope.row.cr_status === null || scope.row.cr_status === 'approve_edit' || ( scope.row.cr_status === 'reject_request' && scope.row.active_status === 1 ) ? 'ให้บริการตามปกติ' : cr_status_th[scope.row.cr_status] }}</template>
                    <!-- <template slot-scope="scope" > {{ scope.row.cr_status !== null && scope.row.cr_status !== 'approve_edit' ? cr_status_th[scope.row.cr_status] : 'ให้บริการตามปกติ' }}</template> -->
                  </el-table-column>
                  <el-table-column prop="promotion_code" sortable label="รหัสรายการส่งเสริมการขาย" width="220" ></el-table-column>
                  <el-table-column prop="promotion_name_th" sortable label="ชื่อรายการส่งเสริมการขาย (ภาษาไทย)" width="290"></el-table-column>
                  <el-table-column prop="promotion_name_en" sortable label="ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)" width="310"></el-table-column>
                  <el-table-column prop="promotion_technology" sortable label="ประเภทเทคโนโลยีการให้บริการ" width="245"></el-table-column>
                  <el-table-column prop="promotion_type" sortable label="ชนิดของรายการส่งเสริมการขาย" width="250"></el-table-column>
                  <el-table-column label="ระยะเวลา" align="center">
                    <el-table-column prop="start_sale_date" sortable="custom" label="เริ่มต้นของการเสนอขาย" width="200"></el-table-column>
                    <el-table-column prop="end_sale_date" sortable="custom" label="สิ้นสุดของการเสนอขาย" width="200"></el-table-column>
                    <el-table-column prop="start_service_date" sortable="custom" label="เริ่มต้นของการให้บริการ" width="200"></el-table-column>
                    <el-table-column prop="end_service_date" sortable="custom" label="สิ้นสุดของการให้บริการ" width="200"></el-table-column>
                  </el-table-column>
                  <el-table-column prop="promotion_price" sortable label="ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน (บาท)" width="350"></el-table-column>
                  <el-table-column label="สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ" align="center">
                    <el-table-column label="บริการ Internet" align="center">
                      <el-table-column prop="download_speed" sortable label="ความเร็วดาวน์โหลด Mbps" width="220"></el-table-column>
                      <el-table-column prop="upload_speed" sortable label="ความเร็วอัปโหลด Mbps" width="220"></el-table-column>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="สิทธิพิเศษ (ที่ไม่มีค่าบริการ)" align="center">
                    <el-table-column prop="privilege_content_th"  sortable label="บริการความบันเทิง (Contents) (ภาษาไทย)" width="320"></el-table-column>
                    <el-table-column prop="privilege_mobile_th"   sortable label="บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย)" width="270"></el-table-column>
                    <el-table-column prop="privilege_wifi_th"     sortable label="บริการ WiFi (ภาษาไทย)" width="200"></el-table-column>
                    <el-table-column prop="privilege_premium_th"  sortable label="พรีเมียม (ภาษาไทย)" width="220"></el-table-column>
                    <el-table-column prop="privilege_device_th"   sortable label="อุปกรณ์อื่น ๆ (ภาษาไทย)" width="210"></el-table-column>
                    <el-table-column prop="privilege_other_th"    sortable label="การให้บริการอื่นๆ (ภาษาไทย)" show-overflow-tooltip height="200" width="230"></el-table-column>
                  </el-table-column>
                  <el-table-column label="อัตราค่าบริการต่อหน่วย" align="center">
                    <el-table-column label="บริการ Internet" align="center">
                      <el-table-column prop="internet_per_Mbps" sortable label="(บาท/Mbps)" width="245" align="center" ></el-table-column>
                    </el-table-column>
                  </el-table-column>
                 <el-table-column prop="promotion_link_url" sortable label="ลิงก์เว็บไซต์ หรือลิงก์ของรายการส่งเสริมการขายของผู้ให้บริการ" width="445"></el-table-column>
                    <el-table-column 
                      label="จัดการ" 
                      align="center" 
                      width="240" 
                      fixed="right"
                      >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="success"
                            @click="handleView(scope.$index, scope.row)"
                          >
                            <i class="el-icon-view"></i>
                          </el-button>
                        </el-tooltip>
                        <template v-if="!scope.row.deleted_at">
                          <template v-if="isProvider && user_permission.edit">  <!--  OPER -->
                            <template v-if="!scope.row.cr_status || scope.row.cr_status == 'approve_edit'">
                              <el-tooltip class="item" effect="light" content="ส่งคำร้อง" placement="top" :enterable="false">
                                <el-button
                                  class="custom-btn"
                                  size="mini"
                                  type="info"
                                  @click="handleRequest(scope.row)"
                                >
                                  <i class="el-icon-message"></i>
                                </el-button>
                              </el-tooltip>
                            </template>
                            <template v-else-if="['reject_request','reject_edit'].includes(scope.row.cr_status)">
                              <el-tooltip class="item" effect="light" content="สถานะ" placement="top" :enterable="false">
                                <el-button
                                  size="mini"
                                  type="primary"
                                  @click="handleInfo(scope.row)"
                                  >
                                    <i class="el-icon-info"></i>
                                </el-button>
                              </el-tooltip>
                            </template>
                            <template v-else>
                              <el-tooltip class="item" effect="light" content="แก้ไข" placement="top" :enterable="false">
                                <el-button
                                  :disabled="scope.row.cr_status !== 'approve_request'"
                                  size="mini"
                                  type="primary"
                                  @click="handleEdit(scope.row)"
                                >
                                  <i class="el-icon-edit"></i>
                                </el-button>
                              </el-tooltip>
                            </template>
                          </template>
                          <el-tooltip class="item" effect="light" content="ประวัติ" placement="top">
                            <el-button
                              class="custom-btn"
                              size="mini"
                              type="warning"
                              @click="viewhistory(scope.row)"
                            >
                              <i class="el-icon-time"></i>
                            </el-button>
                          </el-tooltip>
                          <template v-if="scope.row.active_status == 1" >
                            <el-tooltip class="item" effect="light" content="ระงับชั่วคราว" placement="top" :enterable="false">
                              <el-button
                                v-if="!isProvider"
                                class="custom-btn"
                                size="mini"
                                type="danger"
                                @click="suspendAlert(scope.row)"
                              >
                                <i class="el-icon-warning-outline"></i>
                              </el-button>
                            </el-tooltip>
                          </template>
                          <template v-else> <!--  ADMIN -->
                            <el-tooltip class="item" effect="light" content="ยกเลิกการระงับชั่วคราว" placement="top" :enterable="false">
                              <el-button
                                v-if="!isProvider"
                                class="custom-btn"
                                size="mini"
                                type="primary"
                                @click="publishConfirm(scope.row)"
                              >
                                <i class="el-icon-warning-outline"></i>
                              </el-button>
                            </el-tooltip>
                          </template>
                          <template v-if="!scope.row.cr_status || ['approve_edit','reject_request'].includes(scope.row.cr_status)">
                            <el-tooltip class="item" effect="light" content="ลบ" placement="top" v-if="user_permission.delete">
                              <el-button
                                class="custom-btn"
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.row)"
                                >
                                <i class="el-icon-delete-solid"></i>
                              </el-button>
                            </el-tooltip>
                          </template>
                          <template v-else-if="isProvider && !(scope.row.active_status == 0 && scope.row.cr_status == 'approve_request')">
                            <el-tooltip class="item" effect="light" content="ยกเลิกคำร้อง" placement="top">
                              <el-button
                                class="custom-btn"
                                size="mini"
                                type="danger"
                                @click="handleCancelRequest(scope.row)"
                                >
                                <i class="el-icon-close"></i>
                              </el-button>
                            </el-tooltip>
                          </template>
                        </template>
                      </template><!--  scope -->
                    </el-table-column>
                  </data-tables-server>
                  <!-- dialog view promotion -->
                  <el-dialog v-if="dialogFormVisible" title="รายละเอียดรายการส่งเสริมการขาย" :visible.sync="dialogFormVisible">
                      <template v-if="data_dialog.deleted_at">
                        <h4><b>วันที่ลบรายการส่งเสริมการขาย : </b>
                        <span>{{ this.data_dialog.deleted_at }}</span> </h4>
                        <h4><b>ชื่อผู้ลบรายการส่งเสริมการขาย : </b>
                        <span>{{ this.data_dialog.deleted_by }}</span> </h4>
                        <br>
                      </template>
                      <h5>รหัสรายการส่งเสริมการขาย : 
                        <span>{{ this.data_dialog.promotion_code }}</span> </h5>
                      <h5>ชื่อรายการส่งเสริมการขาย (ภาษาไทย) :
                        <span>{{ this.data_dialog.promotion_name_th }}</span> </h5>
                      <h5>ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ) : 
                        <span>{{ this.data_dialog.promotion_name_en }}</span> </h5>
                      <h5>ประเภทเทคโนโลยีของการให้บริการ : 
                        <span>{{ this.data_dialog.promotion_technology }}</span> </h5>
                      <h5>ชนิดของรายการส่งเสริมการขาย (รายการส่งเสริมการขายหลัก/รายการส่งเสริมการขายเสริม) : 
                        <span>{{ this.data_dialog.promotion_type }}</span> </h5>
                      <h5>ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน (บาท) : 
                        <span>{{ this.data_dialog.promotion_price }}</span> </h5>
                      <h5>ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย) : 
                        <span>{{ this.data_dialog.promotion_condition_th }}</span> </h5>
                      <h5>ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ) : 
                        <span>{{ this.data_dialog.promotion_condition_en }}</span> </h5>
                      <h5>ลิงก์เว็บไซต์ หรือ ลิงก์รายการส่งเสริมการขาย ของผู้ให้บริการ : 
                        <span>{{ this.data_dialog.promotion_link_url }}</span> </h5>
                      <h5>ลิงก์รูปโฆษณา หรือรูปรายการส่งเสริมการขาย : 
                        <span>{{ this.data_dialog.promotion_banner }}</span> </h5>
                      <br><h4 align="center">ระยะเวลา</h4>
                      <h5>เริ่มต้นของการเสนอขาย : 
                        <span>{{ this.data_dialog.start_sale_date }}</span> </h5>
                      <h5>สิ้นสุดของการเสนอขาย : 
                        <span>{{ this.data_dialog.end_sale_date }}</span> </h5>
                      <h5>เริ่มต้นของการให้บริการ : 
                        <span>{{ this.data_dialog.start_service_date }}</span> </h5>
                      <h5>สิ้นสุดของการให้บริการ : 
                        <span>{{ this.data_dialog.end_service_date }}</span> </h5>
                      <br><h4 align="center">สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ</h4>
                      <br><h4>บริการ Internet</h4>
                      <h5>ความเร็วดาวน์โหลด(Mbps) : 
                        <span>{{ this.data_dialog.download_speed }}</span> </h5>
                      <h5>ความเร็วอัปโหลด(Mbps) : 
                        <span>{{ this.data_dialog.upload_speed }}</span> </h5>
                      <br><h4>การให้บริการเสริม(ที่คิดค่าใช้บริการ)</h4>
                      <h5>บริการความบันเทิง (ภาษาไทย): 
                        <span>{{ this.data_dialog.content_service_th }}</span> </h5>
                      <h5>บริการความบันเทิง (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.content_service_en }}</span> </h5>
                      <h5>บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย): 
                        <span>{{ this.data_dialog.mobile_service_th }}</span> </h5>
                      <h5>บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.mobile_service_en }}</span> </h5>
                      <h5>บริการ WiFi/Hotspot (ภาษาไทย): 
                        <span>{{ this.data_dialog.wifi_service_th }}</span> </h5>
                      <h5>บริการ WiFi/Hotspot (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.wifi_service_en }}</span> </h5>
                      <h5>บริการ Fixed Line (ภาษาไทย): 
                        <span>{{ this.data_dialog.fixed_line_service_th }}</span> </h5>
                      <h5>บริการ Fixed Line (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.fixed_line_service_en }}</span> </h5>
                      <h5>บริการอุปกรณ์อื่นๆ (ภาษาไทย): 
                        <span>{{ this.data_dialog.device_service_th }}</span> </h5>
                      <h5>บริการอุปกรณ์อื่นๆ (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.device_service_en }}</span> </h5>
                      <h5>การให้บริการอื่นๆ (ภาษาไทย): 
                        <span>{{ this.data_dialog.other_service_th }}</span> </h5>
                      <h5>การให้บริการอื่นๆ (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.other_service_en }}</span> </h5>
                      <br><h4>การให้บริการเสริม(ที่ไม่คิดค่าใช้บริการ)</h4>
                      <h5>บริการความบันเทิง (ภาษาไทย): 
                        <span>{{ this.data_dialog.privilege_content_th }}</span> </h5>
                      <h5>บริการความบันเทิง (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.privilege_content_en }}</span> </h5>
                      <h5>บริการโทรศัพท์เคลื่อนที่ (ภาษาไทย): 
                        <span>{{ this.data_dialog.privilege_mobile_th }}</span> </h5>
                      <h5>บริการโทรศัพท์เคลื่อนที่ (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.privilege_mobile_en }}</span> </h5>
                      <h5>บริการ Wifi (ภาษาไทย): 
                        <span>{{ this.data_dialog.privilege_wifi_th }}</span> </h5>
                      <h5>บริการ Wifi (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.privilege_wifi_en }}</span> </h5>
                      <h5>พรีเมี่ยม (ภาษาไทย): 
                        <span>{{ this.data_dialog.privilege_premium_th }}</span> </h5>
                      <h5>พรีเมี่ยม (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.privilege_premium_en }}</span> </h5>
                      <h5>อุปกรณ์อื่นๆ (ภาษาไทย): 
                        <span>{{ this.data_dialog.privilege_device_th }}</span> </h5>
                      <h5>อุปกรณ์อื่นๆ (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.privilege_device_en }}</span> </h5>
                      <h5>การให้บริการอื่นๆ (ภาษาไทย): 
                        <span>{{ this.data_dialog.privilege_other_th }}</span> </h5>
                      <h5>การให้บริการอื่นๆ (ภาษาอังกฤษ): 
                        <span>{{ this.data_dialog.privilege_other_en }}</span> </h5>
                      <br><h4>อัตราค่าบริการต่อหน่วย</h4>
                      <h5>บริการ อินเทอร์เน็ต (บาท/Mpbs): 
                        <span>{{ this.data_dialog.internet_per_Mbps }}</span> </h5>
                  </el-dialog>
                  <el-dialog title="คำร้องขอแก้ไขข้อมูลรายการส่งเสริมการขาย" :visible.sync="dialogRequest" >
                    <el-form :model="dialogData" :label-position="'top'">
                      <el-form-item label="รหัสรายการส่งเสริมการขาย">
                        {{dialogData.promotion_code}}
                      </el-form-item>
                      <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                        {{dialogData.promotion_name_th}}
                      </el-form-item>
                      <el-form-item label="คำอธิบายการแก้ไขข้อมูล" >
                        <el-input type="textarea" maxlength="250" show-word-limit :rows="5" v-model="dialogData.cr_remark" autocomplete="off"></el-input>
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogRequest = false">ปิดหน้าต่าง</el-button>
                      <el-button type="primary" @click="submitDialog()">ส่งคำร้อง</el-button>
                    </span>
                  </el-dialog>
                  <el-dialog title="สถานะคำร้องขอแก้ไขข้อมูลรายการส่งเสริมการขาย" :visible.sync="dialogReject" >
                    <el-form :model="dialogData" :label-position="'top'">
                      <el-form-item label="รหัสรายการส่งเสริมการขาย">
                        {{dialogData.promotion_code}}
                      </el-form-item>
                      <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                        {{dialogData.promotion_name_th}}
                      </el-form-item>
                      <el-form-item label="สถานะคำร้อง">
                        {{cr_status_th[dialogData.cr_status]}}
                      </el-form-item>
                      <el-form-item label="คำอธิบาย" >
                        {{dialogData.cr_remark}}
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogReject = false">ปิดหน้าต่าง</el-button>
                      <el-button v-if="dialogData.cr_status == 'reject_request'" type="primary" @click="toRequest()">ส่งคำร้องขอแก้ไขอีกครั้ง</el-button>
                      <el-button v-else type="primary" @click="toEdit()">ไปยังหน้าแก้ไขข้อมูล</el-button>
                    </span>
                  </el-dialog>
                  <el-dialog title="ลบข้อมูลอินเทอร์เน็ตประจำที่" :visible.sync="dialogVisible"
                    width="30%"
                    :before-close="handleClose"
                    >
                    <span>กรุณากดยืนยันการลบข้อมูล</span>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogVisible = false">ปิดหน้าต่าง</el-button>
                      <el-button type="primary" @click="dialogVisible = false">ยืนยัน</el-button>
                    </span>
                  </el-dialog>
                  <el-dialog title="ระงับการเผยแพร่ข้อมูลรายการส่งเสริมการขาย" :visible.sync="dialogUnpublish">
                    <el-form :model="unpublishForm">
                      <el-form-item label="รหัสรายการส่งเสริมการขาย">
                        {{ unpublishForm.promotion_code }}
                      </el-form-item>
                      <el-form-item label="เหตุผลของการระงับ" >
                        <el-input v-model="unpublishForm.cr_remark" type="textarea" :rows="3" show-word-limit maxlength="250"></el-input>
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogUnpublish = false">ปิดหน้าต่าง</el-button>
                      <el-button type="primary" @click="suspendConfirm()">ยืนยัน</el-button>
                    </span>
                  </el-dialog>
                  <el-dialog title="ยกเลิกการขอแก้ไขข้อมูลรายการส่งเสริมการขาย" :visible.sync="cancelRequestDialog" >
                    <el-form :model="dialogData" :label-position="'top'">
                      <el-form-item label="รหัสรายการส่งเสริมการขาย">
                        {{dialogData.promotion_code}}
                      </el-form-item>
                      <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                        {{dialogData.promotion_name_th}}
                      </el-form-item>
                      <el-form-item label="เหตุผลการขอยกเลิกแก้ไข" >
                        <el-input type="textarea" maxlength="250" show-word-limit :rows="5" v-model="dialogData.cr_remark" autocomplete="off"></el-input>
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="cancelRequestDialog = false">ปิดหน้าต่าง</el-button>
                      <el-button type="primary" @click="cancelBroadbandRequest(dialogData);cancelRequestDialog = false">ยืนยัน</el-button>
                    </span>
                  </el-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<style>
  .slider_price .el-form-item__content {
    margin-top: 20px;
  }
  .el-slider__runway.show-input {
    width: 90% !important;
    margin: auto auto !important;
  }
  .el-slider__marks-text {
    position: absolute;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    font-size: 14px;
    color: #909399;
    margin-top: 15px;
    text-align: center;
    width: 85px;
  }
  .el-label{
    white-space: nowrap
  }
</style>
<script>
import { mapState,mapActions,mapGetters,mapMutations } from "vuex"
import Cookie from "cookies-js";
export default {
  created() {
    this.$store.dispatch('ListOperator/fetch_table')
    const regex = /Operator/;
    var currentPath = this.$router.currentRoute.path;
    if (regex.test(currentPath)) {
      this.isProvider = true;
    }
  },
  data() {
    return {
      user_permission : {
        add : false,
        edit : false,
        delete : false
      },
      loading:false,
      isProvider: false,
      label_position: "top",
      dialogVisible: false,
      dialogFormVisible: false,
      dialogRequest: false, 
      dialogReject : false,
      dialogData: {},
      form: {
        page : 1,
        pageSize: 10,
        promotion_name: "",
        provider_id: this.store_provider_id || null,
        promotion_type: null,
        service_status: ['S','CS','U','CU'],
        promotion_status : 'active',
        promotion_technology: null,
        date_range: "",
        price_range: [0,0]
      },
      tableProps: {
        border: true,
        stripe: true
      },
      data_dialog : null,
      menu_width : 240,
      dialogUnpublish : false,
      unpublishForm : {},
      monthly_regulate: "",
      upload_type: "",
      cancelRequestDialog: false,
      addPromotionDialog : false
    };
  },
  mounted(){
    const userinfo = this.$cookies.get("user_nbtc")
    const permission = JSON.parse(atob(userinfo.permission)).Manage_internet
    this.form.provider_id = userinfo.provider_id
    this.menu_width = permission.length*80
    this.user_permission.add = permission.includes('add')
    this.user_permission.edit = permission.includes('edit')
    this.user_permission.delete = permission.includes('delete')
  },
  computed: {
    ...mapState({
      table_data : store => store.Manage_internet.lists,
      total : store => store.Manage_internet.total,
      details : store => store.Manage_internet.details,
      store_provider_id : store => store.Manage_internet.provider_id,
      regulate_list : store => store.Manage_internet.regulate_list,
      cr_status_th : store => store.Manage_request.cr_status_th
    }),
    ...mapGetters({
      providers : "ListOperator/list_broadband"
    })
  },
  methods: {
    ...mapActions({
      fetching : "Manage_internet/get_all",
      finding : "Manage_internet/getPromotionById",
      delete : "Manage_internet/delete_promotion",
      getHistory : "Manage_internet/getHistory",
      searching : "Manage_internet/search_promotion",
      sendRequest : "Manage_request/setBroadbandRequestStatus",
      sendSuspendForm: "Manage_request/suspendPromotion",
      cancelBroadbandRequest: "Manage_request/cancelBroadbandRequest"
    }),
    ...mapMutations({
      setDetail : "Manage_internet/SET_DETAILS"
    }),
    loadData(queryInfo){
      this.form = Object.assign(this.form, queryInfo)
      this.loading = true
      this.searching(this.form)
      setTimeout(() => {
        this.data = this.table_data
        this.loading = false
      }, 500);
    },
    handleClose(done) {
      done();
    },
    viewhistory(row) {
      const regex = /Operator/;
      var currentPath = this.$router.currentRoute.path;
      this.getHistory({promotion_id : row.promotion_id})
    },
    add_promotion_dialog(type) {
      this.upload_type = type
      this.monthly_regulate = null
      this.$store.dispatch('Manage_internet/get_regulate_list')
      this.addPromotionDialog = true
    },
    addPromotion(){
      if(this.monthly_regulate){
        this.$store.commit('Manage_internet/PICK_MONTH',this.monthly_regulate)
        this.addPromotionDialog = false
        var path = this.upload_type == 'PDF' ? "Add_file_promotion_internet" : "Add_promotion_internet"
        this.$router.push({ name:  path})
      }else{
        this.$confirm("กรุณาเลือกรอบการนำส่งข้อมูล","แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      }
    },
    changeTooltip(value) {
      if (value == 1600) {
        return "1500 ขึ้นไป";
      }
      return value;
    },
    handleView(index, row) {
      this.data_dialog = row
      this.dialogFormVisible = true
    },
    handleRequest(row){
      this.dialogData = {
        promotion_id : row.promotion_id,
        promotion_code : row.promotion_code,
        promotion_name_th : row.promotion_name_th,
        cr_status : 'request',
        cr_remark : '',
        revision_id : row.revision_id
      }
      this.dialogRequest = true
    },
    handleEdit(row) {
      this.$store.commit('Manage_internet/SET_EDIT_ROW',row)
      this.$router.push({ name: "Edit_promotion_internet" });
    },
    handleDelete(row) {
      this.$confirm("ลบออกจากรายชื่อโปรโมชั่น", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
      .then(() => {
        this.delete({promotion_id : row.promotion_id})
      })
      .catch(() => {});
    },
    submitDialog(){
      var formdata = {}
          formdata.dialogForm = this.dialogData
          formdata.filterForm = this.form
      this.dialogRequest = false
      this.sendRequest(formdata)
    },
    suspendAlert(row){
      if(['approve_request','waiting','reject_edit'].includes(row.cr_status)){
        return this.$confirm("ไม่สามารถระงับรายการส่งเสริมการขายได้เนื่องจากอยู่ระหว่างการดำเนินการแก้ไขข้อมูล","แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      }
      this.$confirm("ระงับรายการส่งเสริมการขายชั่วคราว","แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      }).then(()=>{
        this.unpublishForm = {
          type : 'broadband',
          cr_remark : '',
          cr_status : 'approve_request',
          promotion_code : row.promotion_code,
          promotion_name_th : row.promotion_name_th,
          promotion_id : row.promotion_id,
          revision_id : row.revision_id,
          provider_id : row.provider_id,
          active_status : 0
        }
        this.dialogUnpublish = true
      })
    },
    suspendConfirm(){
      this.sendSuspendForm(this.unpublishForm)
      this.dialogUnpublish = false
      this.current_page = 1
      this.$store.commit('Manage_internet/SET_ACTIVE_STATUS',this.unpublishForm.promotion_id)
    },
    publishConfirm(row){
      this.$confirm("ยกเลิกการระงับรายการส่งเสริมการขาย","แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "primary"
      }).then(()=>{
        this.sendSuspendForm({
          type : 'broadband',
          cr_remark : '',
          cr_status : 'approve_edit',
          promotion_code : row.promotion_code,
          promotion_name_th : row.promotion_name_th,
          promotion_id : row.promotion_id,
          revision_id : row.revision_id,
          provider_id : row.provider_id,
          active_status : 1
        })
        this.current_page = 1
        this.$store.commit('Manage_internet/SET_ACTIVE_STATUS',row.promotion_id)
      })
    },
    handleInfo(row){
      this.dialogData = row
      this.dialogReject = true
    },
    toRequest(row){
      this.dialogReject = false
      this.handleRequest(this.dialogData)
    },
    toEdit(){
      this.handleEdit(this.dialogData)
    },
    handleCancelRequest(row){
      this.cancelRequestDialog = true
      this.dialogData.promotion_code = row.promotion_code
      this.dialogData.promotion_name_th = row.promotion_name_th
      this.dialogData.promotion_id = row.promotion_id
      this.dialogData.revision_id = row.revision_id
      this.dialogData.old_status = row.cr_status
      this.dialogData.active_status = row.active_status
    }
  }
};
</script>
